import { render, staticRenderFns } from "./UserDepartmentTable.vue?vue&type=template&id=9eda9d80"
import script from "./UserDepartmentTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDepartmentTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports